import { Component, HostBinding, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Endpoint, HelpIndex, MessageType } from '../../models/enums';
import { NavigationContentComponent } from '../../models/navigation-content-component';
import { ActionType, ObjectActionListType, Permissions } from '../../models/permission';
import { Profile } from '../../models/profile';
import { CommonService } from '../../services/common/common.service';
import { RestService } from '../../services/rest/rest.service';
import { GenericTreeNode } from '../generic-tree/generic-tree-node';
import { TargetPickerModalComponent } from '../modals/target-picker-modal/target-picker-modal.component';
import { TargetPickerTreeType } from '../target-picker-tree/target-picker-tree.component';
import { WorkflowStep } from '../../models/workflow';
@Component({
    standalone: false,
    selector: 'res-profile-detail',
    templateUrl: './profile-detail.component.html',
    styleUrls: ['./profile-detail.component.scss']
})
export class ProfileDetailComponent implements NavigationContentComponent {
    @ViewChild('contentForm', { static: true }) contentForm: NgForm;
    @HostBinding('class') classes = 'maximized-component';

    profile: Profile;
    originalProfile: Profile;
    isBusy = false;
    isBusyMessage: string;
    handle: string;
    hasProfilesPermissions: boolean;

    get isDirty(): boolean {
        if (this.contentForm) {
            return this.contentForm.dirty;
        }
        return false;
    }
    set isDirty(value: boolean) {
        if (this.contentForm && this.contentForm.control) {
            if (value) {
                this.contentForm.control.markAsDirty();
            } else {
                this.contentForm.control.markAsPristine();
            }
        }
    }

    constructor(private commonService: CommonService, private restService: RestService) { }


    selectedTreeItemChanged = (node: GenericTreeNode, projectHandle?: string): void => {
        this.hasProfilesPermissions = Permissions.checkUserPermission(ObjectActionListType.PROFILES, ActionType.CREATE);
        this.profile = new Profile();
        if (node && node.data && node.data.handle) {
            this.handle = node.data.handle;
            this.isBusyMessage = 'Loading Synthetic Document...';
            this.isBusy = true;
            this.loadData();

        }
    }

    loadData(): void {
        this.restService.post(Endpoint.profileManager_getProfile, {
            handle: this.handle
        }).then(response => {
            if (response && response.profile) {
                response.profile.lastComments = response.profile.lastComments ? response.profile.lastComments : '';
                response.profile.content = response.profile.content ? response.profile.content : '';
                this.profile = response.profile;
                this.originalProfile = new Profile(response.profile);
            }
            this.isDirty = false;
            this.isBusy = false;
        });
    }

    onChanged(): void {
        if (this.profile.lastComments === this.originalProfile.lastComments && this.profile.content === this.originalProfile.content) {
            this.isDirty = false;
        } else {
            this.isDirty = true;
        }
    }

    openSearchByProfile(): void {
        this.commonService.openModal(TargetPickerModalComponent, {
            modalData: { targetPickerTreeType: TargetPickerTreeType.searchByProfile },
            class: 'horizontal-px-700 vertical-percent-80'
        }).then(response => {
            if (response && response.modalResult && response.modalData && response.modalData.target instanceof GenericTreeNode) {
                const target = response.modalData.target as GenericTreeNode;
                const handle = target.data && target.data.view ? target.data.view.handle : target.data.handle;

                if (target.data instanceof WorkflowStep) {
                    response.modalData.target.name = response.modalData.target.data.description;
                }
                this.isBusy = true;
                this.isBusyMessage = 'Searching ...';
                this.restService.post(Endpoint.viewManager_searchByDoc, {
                    attributes: [{
                        name: 'searchbyprofile',
                        value: this.profile.name
                    }],
                    sourceDocHandle: this.profile.documentHandle,
                    viewHandleList: [handle],
                    taskDescription: 'Search by synthetic document ' + this.profile.name + ' in ' + target.name,
                    threshold: response.modalData.threshold
                }).then(() => {
                    this.isBusy = false;
                }, () => {
                    this.isBusy = false;
                });
            }
        });
    }

    openHelp = (): void => this.commonService.openHelp(HelpIndex.myedisc_profile_document_tab_dlg);

    discardChangesProfileDetail(): void {
        this.loadData();
        this.isDirty = false;
    }

    isPageDirty(): boolean { return this.isDirty; }

    saveChangesWithPromise(): Promise<boolean> {
        this.isBusy = true;
        this.isBusyMessage = 'Updating Synthetic Document...';
        return new Promise<boolean>((resolve) => {
            this.restService.post(Endpoint.profileManager_setContent, {
                handle: this.profile.handle, content: this.profile.content, comments: this.profile.lastComments,
                taskDescription: 'Setting synthetic document content for ' + this.profile.name
            }).then(response => {
                resolve(true);
                this.loadData();
            }, error => {
                resolve(false);
                this.isBusy = false;
            });
        });
    }
}
